/**
 * SessionTimer constuctor 
 * @param {string} timeoutLength - timout length
 * @param {string} approachingBuffer - approaching Buffer
 * @param {string} cbEvent - cb Event
 * @returns {Object} An object containing method name.
 */
function SessionTimer({timeoutLength, approachingBuffer, cbEvent}) {
    
    let timer;
    const COMPLETE_EVENT = 'COMPLETE_EVENT';
    const APPROACHING_TIMEOUT_EVENT = 'APPROACHING_TIMEOUT_EVENT';
    const START_EVENT = 'START_EVENT';
    const STOP_EVENT = 'STOP_EVENT';
    
    const triggerEvent = (eventId) => {
        if(typeof cbEvent === 'function') {
            cbEvent(eventId);
        }
    }
    const onComplete = () => {
        if (timer) {
            clearTimeout(timer);
        }
        if (cbEvent) {
            triggerEvent(COMPLETE_EVENT);
        }
    };
    
    const onApproachingComplete = () => {
        if (timer) {
            clearTimeout(timer);
        }
        triggerEvent(APPROACHING_TIMEOUT_EVENT);
        timer = setTimeout(onComplete, approachingBuffer);
    };
    
    const start = () => {
        if (timer) {
            clearTimeout(timer);
        }
        timer = setTimeout(onApproachingComplete, timeoutLength - approachingBuffer);
        triggerEvent(START_EVENT);
    };
    
    const stop = () => {
        if (timer) {
            clearTimeout(timer);
            triggerEvent(STOP_EVENT);
        }
    }
  
    return {start,stop};
}

module.exports = {
    sessionTimeoutModal: function () {
        const $this = $('#sessionModal');

        // Return early if no matching element found
        if ($this.length === 0 || $this.data("isGuestCustomer")) return this;
    
        // Plugin Settings
        const settings = Object.assign({
            timeoutLength: parseInt($this.data("timeoutLength"), 10),
            approachingBuffer: parseInt($this.data("approachingBuffer"), 10),
            $timeoutEl: $($this.data('timeoutTarget')),
            $approachingTimeoutEl: $($this.data('approachingTimeoutTarget')),
            resetOnAjax: $this.data('resetOnAjax') === true
        });
            
        // Timeout UI Event Handling
        const handleStart = () => {
            settings.$timeoutEl.modal('hide');
            settings.$approachingTimeoutEl.modal('hide');
        }
        const handleOnApproachingComplete = () => {
            settings.$timeoutEl.modal('hide');
            settings.$approachingTimeoutEl.modal('show');
        }
        const handleOnComplete = () => {
            settings.$timeoutEl.modal('show');
            settings.$approachingTimeoutEl.modal('hide');
        }
    
        // Timer Callback
        const timerCallback = (eventId) => {
            switch (eventId) {
                case 'COMPLETE_EVENT':
                    handleOnComplete();
                    break;
                case 'APPROACHING_TIMEOUT_EVENT':
                    handleOnApproachingComplete();
                    break;
                case 'START_EVENT':
                    handleStart();
                    break;
                default:
                    break;
            }
        }
    
        // Initialize the countown timer
        const sessionTimer = new SessionTimer({
            timeoutLength: settings.timeoutLength,
            approachingBuffer: settings.approachingBuffer,
            cbEvent: timerCallback
        });
        sessionTimer.start();
    
        // Approaching Timeout - Modal Content UI Handling
        $(settings.$approachingTimeoutEl.find('form')).on('submit', function (e) {
            e.preventDefault();
            const url = $(this).attr('action');
            $.ajax({
                url: url,
                type: 'get',
                success: function () {
                    sessionTimer.start();
                },
            });
        });  
    
        // Ajax Reset Handling
        if (settings.resetOnAjax) {
            $(document).on( "ajaxSend", function(e) {
                if (window.location.hostname === e.delegateTarget.domain) {
                    sessionTimer.start();
                }
            });
        }
        
        return this;
    }
};
